import React, { useState } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Celebrity } from './components/Celebrity';
import { Services } from './components/Services';
import { Gallery } from './components/Gallery';
import { BeforeAfter } from './components/BeforeAfter';
import { Footer } from './components/Footer';
import { BookingModal } from './components/BookingModal';
export function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  return <div className="min-h-screen bg-brand-light font-sans selection:bg-brand-purple selection:text-white" data-id="element-0">
      <Header onBookClick={handleOpenModal} data-id="element-1" />

      <main data-id="element-2">
        <Hero onBookClick={handleOpenModal} data-id="element-3" />
        <About data-id="element-4" />
        <Celebrity data-id="element-5" />
        <Services data-id="element-6" />
        <BeforeAfter data-id="element-7" />
        <Gallery data-id="element-8" />
      </main>

      <Footer data-id="element-9" />

      <BookingModal isOpen={isModalOpen} onClose={handleCloseModal} data-id="element-10" />
    </div>;
}